import { useIntl } from 'react-intl';

import { DumbCardBack } from 'components/card/Back/DumbCardBack';
import { FRONTEND_ASSET_HOST } from 'constants/assets';

export const BackCoinReward = () => {
  const { formatMessage } = useIntl();

  return (
    <DumbCardBack
      aria-label={formatMessage({
        id: 'Rewards.CoinReward',
        defaultMessage: 'Coin reward',
      })}
      path={`${FRONTEND_ASSET_HOST}/cards/back/coin.png`}
      radius="10px"
    />
  );
};
